import React from "react";
import ReactDOM from "react-dom";
import LeftContainer from "./components/LeftContainer";
import RightContainer from "./components/RightContainer";
import styled from "styled-components";
import "./styles.css";

const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-family: -apple-system, BlinkMacSystemFont, "Roboto", "Segoe UI", "Oxygen",
    "Ubuntu", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;

  @media (max-width: 1024px) {
    flex-direction: column;
    height: 100%;
  }
`;

function App() {
  return (
    <Container className="App">
      <LeftContainer />
      <RightContainer />
    </Container>
  );
}

const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement);
